export enum UpdateWizardStep {
  SELECT_ENTITY = 0,
  EDIT_DETAILS = 1,
  EDIT_ENTITLEMENTS = 2,
  EDIT_REGIONS_QUESTIONS = 3,
  REVIEW = 4,
}

export enum EntityType {
  PRODUCT = 'product',
  ENTITLEMENT = 'entitlement',
  ORG_ENTITLEMENT = 'org_entitlement',
  DEPENDENT_SERVICE = 'dependent_service',
  SKU_STANDALONE = 'sku_standalone',
  SKU_SUITE = 'sku_suite',
  SKU_ADDON = 'sku_addon',
}

export interface UpdateOperation {
  entityType: EntityType;
  entityId: string;
  entityName: string;
  updates: Record<string, unknown>;
  originalData: Record<string, unknown>;
}

export interface UpdateWizardState {
  currentStep: UpdateWizardStep;
  selectedEntity: EntityType | null;
  selectedEntityData: Record<string, unknown> | null;
  updates: UpdateOperation[];
  relatedUpdates: UpdateOperation[];
  productEntity: UpdateOperation[];
  loading: boolean;
  error: string | null;
}

export interface Product {
  product_id: string;
  product_name: string;
  product_description?: string;
  product_category?: string;
  sase_product?: boolean;
  product_code?: string;
  created_at?: string;
  updated_at?: string;
}

export interface Entitlement {
  entitlement_id: string;
  entitlement_name: string;
  entitlement_description?: string;
  entitlement_value?: string;
  entitlement_units?: string;
  product_id?: string;
  product_name?: string;
  created_at?: string;
  updated_at?: string;
}

export interface OrgEntitlement {
  org_entitlement_id: string;
  org_entitlement_name: string;
  org_entitlement_description?: string;
  org_entitlement_value?: string;
  org_entitlement_units?: string;
  product_id?: string;
  product_name?: string;
  created_at?: string;
  updated_at?: string;
}

export interface Sku {
  sku_id: string;
  sku_name: string;
  sku_description?: string;
  sku_type: 'standalone' | 'suite' | 'add-on';
  product_id?: string;
  product_name?: string;
  created_at?: string;
  updated_at?: string;
}

export interface ProductSkuConfig {
  product_id: string;
  product_name: string;
  sku_type: 'standalone' | 'suite' | 'add-on';
  skus: Array<{
    sku_id: string;
    sku_name: string;
  }>;
  entitlements: Array<{
    entitlement_id: string;
    entitlement_name: string;
  }>;
  org_entitlements: Array<{
    org_entitlement_id: string;
    org_entitlement_name: string;
  }>;
}

export interface EntityListResponse<T> {
  data: T[];
  total: number;
}
